var map = {
	"./de.json": "./src/langs/de.json",
	"./en_uk.json": "./src/langs/en_uk.json",
	"./en_us.json": "./src/langs/en_us.json",
	"./es.json": "./src/langs/es.json",
	"./es_la.json": "./src/langs/es_la.json",
	"./fr.json": "./src/langs/fr.json",
	"./pt.json": "./src/langs/pt.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/langs recursive ^\\.\\/.*\\.json$";


//////////////////
// WEBPACK FOOTER
// ./src/langs ^\.\/.*\.json$
// module id = ./src/langs recursive ^\.\/.*\.json$
// module chunks = 1